@if (isLoading) {
  <div class="loading">
    <mat-progress-spinner [diameter]="64" [strokeWidth]="2" mode="indeterminate"></mat-progress-spinner>
  </div>
}
@if (!isLoading) {
  <div class="action-flyout-wrapper" [ngClass]="typePage?.toLowerCase() || 'editor-automation'">
    <div
      class="action-container"
      [ngClass]="action.nameAction.toLowerCase()"
      [ngClass]="[action.translationKey.toLowerCase(), action.nameAction.toLowerCase()]">
      @if (typePage === "Automation") {
        <div class="action-name">
          {{ "automations.actions." + action.translationKey + ".title" | translate }}
          @if (action.docsUrl) {
            <a class="action-docs-link" [href]="action.docsUrl" target="_blank" rel="noopener">
              <mat-icon>open_in_new</mat-icon>
              {{ "generic.for-more-information" | translate }}
            </a>
          }
        </div>
      }
      @if (!ActionUpdateField.includes(action.$type) && action.$type !== ACTIONS_TYPES.VoyadoUpdateConsentPreferences) {
        <div class="action-properties-wrapper simple-field-action">
          @for (prop of properties; track prop) {
            <!-- Additional info at the top -->
            @if (prop.additionalUnderInfoKey) {
              <div class="instruction-prop" [innerHTML]="'automations.actions.' + action.translationKey + '.' + prop.additionalUnderInfoKey | translate"></div>
            }
            <div class="property-wrapper" [ngClass]="prop.typeInput" [ngClass]="[prop.typeInput, action.nameAction.toLowerCase()]">
              @if (prop.isRunningInRealTime && (prop.addExtraTagForRunningInRealTime || (!prop.addExtraTagForRunningInRealTime && isListAlwaysAdded))) {
                <div class="item-added list-added">
                  <img class="green-check" src="../../../../assets/img/green-check.svg" alt="" />
                  @if (prop.addExtraTagForRunningInRealTime) {
                    <span>
                      {{
                        "automations.lists-added" | translate: { type: ("automations.actions." + action.translationKey + ".subscription-topics" | translate) }
                      }}
                    </span>
                  }
                  @if (!prop.addExtraTagForRunningInRealTime && isListAlwaysAdded) {
                    <span>
                      {{
                        "automations.list-added"
                          | translate
                            : { type: ("automations.actions." + action.translationKey + (prop.name === PROPS_TYPE.TagIds ? ".tag" : ".list") | translate) }
                      }}
                    </span>
                  }
                </div>
              }
              @if (
                !prop.hide &&
                (!prop.isRunningInRealTime || prop.addExtraTagForRunningInRealTime) &&
                prop.typeInput !== TypeInput.Switch &&
                (nameGroup !== TypeStep.UpdateOtherFields ||
                  (nameGroup === TypeStep.UpdateOtherFields &&
                    (prop.name === PROPS_TYPE.Tags || action.$type === ACTIONS_TYPES.RuleMailerRemoveTagFromSubscriber)))
              ) {
                <div
                  class="property-name"
                  [ngClass]="ActionUpdateTags.includes(action.$type) && prop.name === PROPS_TYPE.Tags ? 'property-name-tag' : prop.translationKey">
                  <span>
                    {{
                      "automations.actions." + action.translationKey + "." + (prop.addExtraTagForRunningInRealTime ? "extraTag.list-in" : prop.translationKey)
                        | translate
                    }}
                    {{ prop.translationKey === "list-in" ? action.nameAction : null }}
                    @if (prop.required || prop.requiredInFormSettings) {
                      <span class="required-marker" aria-hidden="true">*</span>
                    }
                  </span>
                  @if (prop.name === "storeExternalId") {
                    <span class="optional">{{ "generic.optional" | translate }}</span>
                  }
                </div>
              }
              @if (prop.typeInput === TypeInput.List && !prop.hide && (!prop.isRunningInRealTime || prop.addExtraTagForRunningInRealTime)) {
                @if (nameGroup !== TypeStep.UpdateOtherFields || action.$type === ACTIONS_TYPES.RuleMailerRemoveTagFromSubscriber) {
                  <mat-form-field class="list-dropdown" appearance="outline" [ngClass]="[prop.translationKey, action.nameAction.toLowerCase()]">
                    <mat-select
                      [(ngModel)]="prop.value"
                      [disabled]="!prop.listUI"
                      #listSelectModel="ngModel"
                      [required]="prop.required"
                      (selectionChange)="setListIdOnFieldProperty(prop, index)"
                      (mouseenter)="onMouseEnter()"
                      (mouseleave)="onMouseLeave()"
                      [placeholder]="
                        ('automations.actions.' +
                          action.translationKey +
                          '.' +
                          (prop.addExtraTagForRunningInRealTime ? 'extraTag.select-tag' : prop.translationKey) | translate) +
                        (prop.translationKey === 'list-in' ? ' ' + action.nameAction : '')
                      ">
                      @if (prop.addEmptyOption) {
                        <mat-option [innerHtml]="'generic.none' | translate" class="empty-option"></mat-option>
                      }
                      @for (item of prop.listUI?.length ? prop.listUI : []; track item) {
                        <mat-option [value]="action.$type !== ACTIONS_TYPES.TriggerbeeCartAbandonment ? item.id || item.email || item : item.name">
                          <span [innerHtml]="item.displayName || item.name || item.email || item | allowHtml"></span>
                        </mat-option>
                      }
                    </mat-select>
                    @if (
                      (prop.isRunningInRealTime &&
                        prop.$type === ACTIONS_TYPES.RuleMailerAddTagToSubscriber &&
                        prop.required &&
                        !prop.value &&
                        listSelectModel.touched &&
                        (typePage === "Automation" || isActionRequiredList)) ||
                      (prop.requiredInFormSettings && !prop.addEmptyOption && !prop.value && listSelectModel.touched && typePage !== "Automation")
                    ) {
                      <mat-hint class="error-message">
                        {{ "generic.validation.error-required" | translate }}
                      </mat-hint>
                    }
                    @if (missingTagsOrLists?.length) {
                      <mat-hint class="error">
                        {{ "automations.tag-not-in-list" | translate }}:
                        {{ missingTagsOrLists.join(", ") }}
                      </mat-hint>
                    }
                  </mat-form-field>
                }
              }
              @if (prop.typeInput === TypeInput.ListMultiSelect) {
                <mat-form-field class="list-dropdown" appearance="outline" [ngClass]="prop.translationKey">
                  <mat-select
                    multiple
                    [(ngModel)]="prop.value"
                    [disabled]="!prop.listUI"
                    #listSelectModel="ngModel"
                    [required]="prop.required"
                    (selectionChange)="setListIdOnFieldProperty(prop, index)"
                    [placeholder]="'automations.actions.' + action.translationKey + '.' + prop.translationKey | translate">
                    @for (item of prop.listUI?.length ? prop.listUI : []; track item) {
                      <mat-option [value]="item.id || item.email || item">
                        {{ item.name || item.displayName || item.email || item }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (
                    (prop.required && !prop.value && listSelectModel.touched && (typePage === "Automation" || isActionRequiredList)) ||
                    (prop.requiredInFormSettings && !prop.value && listSelectModel.touched && typePage !== "Automation")
                  ) {
                    <mat-hint class="error-message">
                      {{ "generic.validation.error-required" | translate }}
                    </mat-hint>
                  }
                  @if (missingTagsOrLists?.length) {
                    <mat-hint class="error">
                      {{ "automations.tag-not-in-list" | translate }}:
                      {{ missingTagsOrLists.join(", ") }}
                    </mat-hint>
                  }
                </mat-form-field>
              }
              @if (prop.typeInput === TypeInput.Text && !ActionUpdateTags.includes(action.$type)) {
                <mat-form-field class="list-dropdown" appearance="outline" [ngClass]="prop.translationKey">
                  <input
                    #textInput="ngModel"
                    matInput
                    [required]="prop.required"
                    [(ngModel)]="prop.value"
                    name="inputName"
                    [placeholder]="'automations.actions.' + action.translationKey + '.' + (prop.placeholder || prop.translationKey) | translate"
                    [disabled]="action.requiredList && !action.listId" />
                  @if (
                    ((prop.required && !prop.value && textInput.touched && typePage === "Automation") ||
                      (prop.requiredInFormSettings && !prop.value && textInput.touched && typePage !== "Automation")) &&
                    !isPropertyUrlInvalid(prop)
                  ) {
                    <mat-hint class="error-message">
                      {{ "generic.validation.error-required" | translate }}
                    </mat-hint>
                  }
                  @if (isPropertyUrlInvalid(prop)) {
                    <mat-hint class="error-message">
                      {{ "generic.validation.error-url" | translate }}
                    </mat-hint>
                  }
                  @if (hasError.isoLangFormat && prop.name === "language") {
                    <mat-hint class="error-message">
                      {{ "generic.validation.error-iso-lang-format" | translate }}
                    </mat-hint>
                  }
                </mat-form-field>
                @if (action.requiredList && !action.listId) {
                  <div class="error-no-list">{{ "automations.errorMessages.List-is-required" | translate }}</div>
                }
              }
              <!-- Tags update -->
              @if (prop.typeInput === TypeInput.Text && ActionUpdateTags.includes(action.$type)) {
                @for (valueItem of propValueTags; track valueItem; let i = $index) {
                  <div class="tags-fields-wrapper">
                    <mat-form-field class="list-dropdown" appearance="outline" [ngClass]="prop.translationKey">
                      <input
                        #textInput="ngModel"
                        matInput
                        [required]="prop.required"
                        [(ngModel)]="valueItem.value"
                        name="inputName"
                        [placeholder]="'automations.actions.' + action.translationKey + '.' + prop.translationKey | translate"
                        [disabled]="action.requiredList && !action.listId"
                        (ngModelChange)="setTagValue(prop)" />
                      @if (prop.required && !valueItem.value && textInput.touched && typePage === "Automation") {
                        <mat-hint class="error-message">
                          {{ "generic.validation.error-required" | translate }}
                        </mat-hint>
                      }
                    </mat-form-field>
                    @if (valueItem.value || (!valueItem.value && propValueTags.length > 1)) {
                      <div>
                        <button class="remove-button on-tag" mat-stroked-button (click)="deleteTagFields(i, prop)">
                          <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
                        </button>
                      </div>
                    }
                  </div>
                }
                @if (action.requiredList && !action.listId) {
                  <div class="error-no-list">{{ "automations.errorMessages.List-is-required" | translate }}</div>
                }
                <div>
                  <button class="secondary-button transparent-button tag-add-btn" mat-stroked-button [disabled]="!isBtnAddTagEnabled">
                    <span class="btn-label" (click)="addTagFields()">
                      +
                      <span class="text-add">{{ "generic.add" | translate }}</span>
                    </span>
                  </button>
                </div>
              }
              @if (prop.typeInput === TypeInput.Number) {
                <mat-form-field class="list-dropdown" appearance="outline" [ngClass]="prop.translationKey">
                  <input
                    #numberInput="ngModel"
                    matInput
                    type="number"
                    [required]="prop.required"
                    [(ngModel)]="prop.value"
                    name="inputName"
                    [placeholder]="'automations.actions.' + action.translationKey + '.' + prop.translationKey | translate" />
                  @if (prop.required && typePage === "Automation" && (prop.value < 0 || hasError.allZero)) {
                    <mat-hint class="error-message">
                      {{ "generic.validation.error-required" | translate }}
                    </mat-hint>
                  }
                </mat-form-field>
              }
              @if (prop.typeInput === TypeInput.TextArea) {
                <mat-form-field appearance="outline" appearance="outline" [ngClass]="prop.translationKey">
                  <textarea
                    #areaInput="ngModel"
                    [required]="prop.required"
                    matInput
                    [(ngModel)]="prop.value"
                    [placeholder]="'automations.actions.' + action.translationKey + '.' + prop.translationKey | translate"></textarea>
                  @if (
                    (prop.required && !prop.value && areaInput.touched && typePage === "Automation") ||
                    (prop.requiredInFormSettings && !prop.value && areaInput.touched && typePage !== "Automation")
                  ) {
                    <mat-hint class="error-message">
                      {{ "generic.validation.error-required" | translate }}
                    </mat-hint>
                  }
                </mat-form-field>
              }
              @if (prop.typeInput === TypeInput.FieldMappingDictionary) {
                <div class="field-mapping-editor" [ngClass]="prop.translationKey">
                  @for (row of fieldMappingRows[prop.name]; track $index; let rowIndex = $index) {
                    <div class="field-mapping-row">
                      <ng-select
                        [appendTo]="appendDropdownToBody ? 'body' : null"
                        class="field-mapping-source custom-select"
                        [appearance]="'outline'"
                        [items]="triggerbeeFieldsList"
                        bindLabel="label"
                        bindValue="value"
                        groupBy="group"
                        [addTag]="true"
                        [clearable]="false"
                        [dropdownPosition]="'bottom'"
                        [placeholder]="'automations.actions.' + action.translationKey + '.fieldMappingSource' | translate"
                        [ngModel]="row.sourceField"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="setFieldMappingSource(prop, rowIndex, $event)"
                        (change)="onFieldMappingSourcePicked(prop, rowIndex, $event)">
                        <ng-template ng-optgroup-tmp let-item="item">
                          {{ item.group | translate }}
                        </ng-template>
                      </ng-select>
                      <mat-icon class="field-mapping-arrow">arrow_forward</mat-icon>
                      <mat-form-field class="field-mapping-destination" appearance="outline" floatLabel="always">
                        <mat-label>{{ "automations.actions." + action.translationKey + ".fieldMappingDestination" | translate }}</mat-label>
                        <input
                          matInput
                          [ngModel]="row.destinationPath"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="setFieldMappingDestination(prop, rowIndex, $event)"
                          [placeholder]="'automations.actions.' + action.translationKey + '.fieldMappingDestinationPlaceholder' | translate" />
                        @if (row.sourceField && !row.destinationPath) {
                          <mat-hint class="error-message">
                            {{ "generic.validation.error-required" | translate }}
                          </mat-hint>
                        }
                      </mat-form-field>
                      <button
                        mat-icon-button
                        type="button"
                        class="field-mapping-remove-btn"
                        [disabled]="fieldMappingRows[prop.name].length === 1 && !row.sourceField && !row.destinationPath"
                        (click)="removeFieldMappingRow(prop, rowIndex)">
                        <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
                      </button>
                    </div>
                  }
                  <button mat-stroked-button type="button" class="field-mapping-add-btn" (click)="addFieldMappingRow(prop)">
                    <mat-icon>add</mat-icon>
                    {{ "automations.actions." + action.translationKey + ".fieldMappingAdd" | translate }}
                  </button>
                </div>
              }
              @if (prop.typeInput === TypeInput.ListSelect) {
                <ng-select
                  [appendTo]="appendDropdownToBody ? 'body' : null"
                  [items]="prop.listUI?.length ? prop.listUI : []"
                  bindLabel="label"
                  bindValue="value"
                  groupBy="group"
                  (change)="onDropdownSelectChange(prop, $event)"
                  [placeholder]="'automations.actions.' + action.translationKey + '.' + prop.translationKey | translate"
                  [addTag]="true"
                  [required]="true"
                  [clearable]="false"
                  dropdownPosition="bottom"
                  [(ngModel)]="prop.value"
                  name="mySelect"
                  #mySelect="ngModel">
                  <ng-template ng-optgroup-tmp let-item="item">
                    {{ item.group | translate }}
                  </ng-template>
                </ng-select>
                @if (prop.required && !prop.value && mySelect.touched && typePage === "Automation") {
                  <span class="error-message error-ng-select-message">
                    {{ "generic.validation.error-required" | translate }}
                  </span>
                }
              }
              @if (
                prop.typeInput === TypeInput.Switch &&
                action.nameAction !== "Voyado" &&
                prop.name !== "isRunningInRealTime" &&
                (action.nameAction === "Rule" || action.nameAction === "Dotdigital" || action.nameAction === "Omnisend" || showsTagProfileSwitch())
              ) {
                <div class="switch">
                  <mat-slide-toggle [(ngModel)]="prop.value">
                    <div [innerHTML]="'automations.actions.' + action.translationKey + '.' + prop.translationKey | translate | allowHtml"></div>
                  </mat-slide-toggle>
                </div>
              }
              @if (
                prop.typeInput === TypeInput.Switch && (action.nameAction === "Voyado" || (prop.name === "isRunningInRealTime" && action.nameAction === "Rule"))
              ) {
                <div class="realtime-switch" [matTooltip]="prop.tooltip | translate" matTooltipPosition="above">
                  <mat-slide-toggle
                    [(ngModel)]="prop.value"
                    (change)="toggleRealTimeVoyado($event, action.nameAction)"
                    [disabled]="prop.disabled || isfieldMappingsPropOnAction || (realTimeSwitchLocked && !prop.value)">
                    <div [innerHTML]="'automations.actions.' + action.translationKey + '.' + prop.translationKey | translate | allowHtml"></div>
                  </mat-slide-toggle>
                </div>
              }
            </div>
            <!-- Additional info at the bottom -->
            @if (
              (prop.additionalInfoKey && typePage === "Automation" && !prop.isRunningInRealTime) ||
              (prop.additionalInfoKey && typePage !== "Automation" && nameGroup !== TypeStep.UpdateOtherFields && action.nameAction !== "Custobar")
            ) {
              <div
                class="instruction-prop"
                [ngClass]="prop.name"
                [innerHTML]="'automations.actions.' + action.translationKey + '.' + prop.additionalInfoKey | translate"></div>
            }
          }
        </div>
      }
      <!-- only for preferences properties -->
      @if (action.$type === ACTIONS_TYPES.VoyadoUpdateConsentPreferences) {
        <div class="action-properties-wrapper simple-field-action update-preferences-wrapper">
          <div class="property-wrapper">
            <div class="property-name">
              <span>{{ "automations.actions." + action.translationKey + ".title" | translate }}:</span>
            </div>
            <mat-form-field class="list-dropdown preferences" appearance="outline">
              <input readonly matInput [matMenuTriggerFor]="menu" [value]="combinedPreferencesProperties" name="inputName" />
            </mat-form-field>
          </div>
          <mat-menu #menu="matMenu">
            <div class="mat-menu-preferences">
              @for (prop of properties; track prop) {
                <div class="mat-menu-preferences-group">
                  <label id="radio-group-preferences">{{ "automations.actions." + action.translationKey + "." + prop.name | translate }}</label>
                  <mat-radio-group [(ngModel)]="prop.value" aria-labelledby="radio-group-preferences">
                    @for (item of prop.listUI; track item) {
                      <mat-radio-button [value]="item.id" (click)="$event.stopPropagation()">
                        {{ "automations.actions." + action.translationKey + "." + item.id | translate }}
                      </mat-radio-button>
                    }
                  </mat-radio-group>
                </div>
              }
            </div>
          </mat-menu>
        </div>
      }
      <!-- only for update field properties -->
      @if (componentsAlwaysAdded?.length && isFieldMapping) {
        <div class="always-added">
          @for (comp of componentsAlwaysAdded; track trackByFn($index, comp)) {
            <div class="item-added">
              <img class="green-check" src="../../../../assets/img/green-check.svg" alt="" />
              <span>{{ "campaign.widget.sidebar.form-settings.item-added" | translate: { item: comp.translationKey | translate } }}</span>
            </div>
          }
        </div>
      }
      @if (ActionUpdateField.includes(action.$type)) {
        <div class="action-properties-wrapper update-field-wrapper">
          <!-- list property only for automation page flyout -->
          @if (action.requiredList) {
            @for (prop of propList; track prop; let index = $index) {
              @if (!isFieldMapping && typePage === "Automation") {
                <div class="only-list-in-update-field">
                  <div class="property-name">
                    <span>
                      {{ "automations.actions." + action.translationKey + "." + prop.translationKey | translate }}
                      {{ prop.translationKey === "list-in" ? action.nameAction : null }}
                    </span>
                  </div>
                  @if (prop.typeInput === TypeInput.List) {
                    <mat-form-field class="list-dropdown" appearance="outline" [ngClass]="prop.translationKey">
                      <mat-select
                        [(ngModel)]="prop.value"
                        [disabled]="!prop.listUI || !prop.listUI.length"
                        #listSelectModel="ngModel"
                        [required]="prop.required"
                        (selectionChange)="setListIdOnFieldProperty(prop, index)"
                        [placeholder]="
                          ('automations.actions.' + action.translationKey + '.' + prop.translationKey | translate) +
                          (prop.translationKey === 'list-in' ? ' ' + action.nameAction : '')
                        ">
                        @if (prop.addEmptyOption) {
                          <mat-option value="none"></mat-option>
                        }
                        @for (item of prop.listUI?.length ? prop.listUI : []; track item) {
                          <mat-option [value]="item.id || item.email || item">
                            {{ item.name || item.displayName || item.email || item }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (prop.required && !prop.value && listSelectModel.touched && (typePage === "Automation" || isActionRequiredList)) {
                        <mat-hint class="error-message">
                          {{ "generic.validation.error-required" | translate }}
                        </mat-hint>
                      }
                    </mat-form-field>
                  }
                  @if (prop.typeInput === TypeInput.ListMultiSelect) {
                    <mat-form-field class="list-dropdown" appearance="outline" [ngClass]="prop.translationKey">
                      <mat-select
                        multiple
                        [(ngModel)]="prop.value"
                        [disabled]="!prop.listUI"
                        #listSelectModel="ngModel"
                        [required]="prop.required"
                        (selectionChange)="setListIdOnFieldProperty(prop, index)"
                        [placeholder]="'automations.actions.' + action.translationKey + '.' + prop.translationKey | translate">
                        @for (item of prop.listUI?.length ? prop.listUI : []; track item) {
                          <mat-option [value]="item.id || item.email || item">
                            {{ item.name || item.displayName || item.email || item }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (
                        (prop.required && !prop.value && listSelectModel.touched && (typePage === "Automation" || isActionRequiredList)) ||
                        (prop.requiredInFormSettings && !prop.value && listSelectModel.touched && typePage !== "Automation")
                      ) {
                        <mat-hint class="error-message">
                          {{ "generic.validation.error-required" | translate }}
                        </mat-hint>
                      }
                    </mat-form-field>
                  }
                </div>
              }
            }
          }
          <!-- field properties -->
          @for (prop of propsField; track prop; let index = $index) {
            <div
              class="update-field-content"
              [ngClass]="[prop.typeInput === TypeInput.ListSelect ? 'trigerbee-field-content' : '', isFieldMapping ? 'update-field-map-content' : '']">
              <ng-container>
                @if (action.requiredList && typePage === "Automation") {
                  <mat-icon class="update-field-arrow" [ngClass]="validPairField[index] && validPairField[index - 1] ? 'valid' : null">
                    <span class="material-icons">arrow_forward</span>
                  </mat-icon>
                }
                @if (!action.requiredList || typePage !== "Automation") {
                  <mat-icon
                    class="update-field-arrow_3"
                    [ngClass]="
                      (validPairField[index] && validPairField[index - 1]) || (!validPairField[index] && !validPairField[index - 1]) || isFieldMapping
                        ? 'valid'
                        : null
                    ">
                    <span class="material-icons">arrow_forward</span>
                  </mat-icon>
                }
                @if (prop.typeInput === TypeInput.List) {
                  <mat-form-field class="list-dropdown" appearance="outline" floatLabel="always">
                    <mat-label>{{ "automations.actions." + action.translationKey + "." + prop.translationKey | translate }} {{ action.nameAction }}</mat-label>
                    <mat-select
                      (selectionChange)="onDropdownSelectChange(prop, $event, index)"
                      [(ngModel)]="prop.value"
                      #listSelectModel="ngModel"
                      [disabled]="!prop.listUI || (noItemsInFieldName && !isFieldMapping) || (action.requiredList && !action.listId && !action.tagIds)">
                      @if (prop.addEmptyOption && typePage !== "Automation" && isFieldMapping) {
                        <mat-option [innerHtml]="'generic.none' | translate" class="empty-option" value="none"></mat-option>
                      }
                      @for (item of prop.listUI?.length ? prop.listUI : []; track item) {
                        <mat-option [value]="item.id || item">
                          {{ item.name || item.displayName || item.email || item }}
                        </mat-option>
                      }
                    </mat-select>
                    @if (prop.required && !prop.value && listSelectModel.touched && typePage === "Automation") {
                      <mat-hint class="error-message">
                        {{ "generic.validation.error-required" | translate }}
                      </mat-hint>
                    }
                  </mat-form-field>
                }
              </ng-container>
              @if (isFieldMapping) {
                <p class="update-map-field-name">{{ prop.mapName }}</p>
              }
              @if (prop.typeInput === TypeInput.ListSelect && !isFieldMapping) {
                <div class="trigerbee-select">
                  <ng-select
                    [appendTo]="appendDropdownToBody ? 'body' : null"
                    [items]="prop.listUI?.length && !prop.mapName ? prop.listUI : prop.listUI?.length && prop.mapName ? listUIforMap : []"
                    bindLabel="label"
                    bindValue="value"
                    groupBy="group"
                    (change)="onDropdownSelectChange(prop, $event, index)"
                    [placeholder]="'automations.actions.' + action.translationKey + '.' + prop.translationKey | translate"
                    [addTag]="onAddTag"
                    [clearable]="false"
                    dropdownPosition="bottom"
                    [(ngModel)]="prop.value"
                    name="mySelect"
                    #mySelect="ngModel"
                    [appearance]="'outline'"
                    class="custom-select"
                    [disabled]="
                      !prop.listUI || (noItemsInFieldName && !isFieldMapping) || (action.requiredList && !action.listId && !action.tagIds) || prop.mapName
                    ">
                    <ng-template ng-optgroup-tmp let-item="item">
                      {{ item.group | translate }}
                    </ng-template>
                  </ng-select>
                  <div class="mat-mdc-form-field-subscript-wrapper">
                    @if (prop.required && !prop.value && mySelect.touched && typePage === "Automation") {
                      <span class="error-message error-ng-select-message">
                        {{ "generic.validation.error-required" | translate }}
                      </span>
                    }
                  </div>
                  @if (prop.value && isFieldMapping) {
                    <div class="green-check floating"><img src="../../../../assets/img/green-check.svg" alt="" /></div>
                  }
                </div>
              }
              @if (index === 0 && (!prop.listUI || (action.requiredList && !action.listId && !action.tagIds))) {
                <div class="error-no-list">
                  {{ "automations.errorMessages.List-is-required" | translate }}
                </div>
              }
              @if (
                ((noItemsInFieldName && !action.requiredList) || (noItemsInFieldName && action.requiredList && (prop.listId || prop.tagIds))) &&
                !isFieldMapping &&
                index === 0
              ) {
                <div class="error-no-list">
                  {{ "automations.integration-should-be-set-up" | translate }}{{ action.nameAction }} {{ "settings.apps.integration" | translate | lowercase }}
                </div>
              }
              @if (prop.typeInput === TypeInput.List && !isFieldMapping) {
                <div>
                  <button class="remove-button on-field" mat-stroked-button (click)="removeField(index)">
                    <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
                  </button>
                </div>
              }
            </div>
          }
          <!-- buttons -->
          @if (!isFieldMapping) {
            <button class="secondary-button transparent-button" [disabled]="isBtnAddFieldDisabled" mat-stroked-button (click)="addOtherFields()">
              <span class="btn-label">
                +
                <span class="text-add">{{ "generic.add" | translate }}</span>
              </span>
            </button>
          }
          @if (isFieldMapping && !propsField.length && !componentsAlwaysAdded.length) {
            <div class="no-input-wrapper">
              <div class="no-input-text">
                <mat-icon>warning</mat-icon>
                <span>{{ "campaign.widget.sidebar.form-settings.no-fields-in-widget" | translate }}</span>
              </div>
            </div>
          }
        </div>
      }
    </div>
    <div class="btns-wrapper">
      <button class="underline-button" (click)="flyoutService.close()" type="button">{{ "generic.cancel" | translate }}</button>
      <button mat-stroked-button class="primary-button save-btn" (click)="saveAction()" [disabled]="isDisabledBtnAddAction">
        {{ "generic.save" | translate }}
      </button>
    </div>
  </div>
}
